var AssessmentResult = /** @class */ (function () {
    function AssessmentResult() {
        this._scaleResults = [];
    }
    Object.defineProperty(AssessmentResult.prototype, "assignmentItemId", {
        get: function () {
            return this._assignmentItemId;
        },
        set: function (v) {
            this._assignmentItemId = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentResult.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (v) {
            this._id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentResult.prototype, "assessment", {
        get: function () {
            return this._assessment;
        },
        set: function (v) {
            this._assessment = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentResult.prototype, "scaleResults", {
        get: function () {
            return this._scaleResults;
        },
        set: function (v) {
            this._scaleResults = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentResult.prototype, "hasResources", {
        get: function () {
            return this.assessment.resourcesURL && this.assessment.resourcesURL != "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentResult.prototype, "hasHomework", {
        get: function () {
            return this.scaleResults.some(this.scaleHasHomework);
        },
        enumerable: true,
        configurable: true
    });
    AssessmentResult.prototype.getScalesWithHomework = function () {
        return this.scaleResults.filter(this.scaleHasHomework);
    };
    Object.defineProperty(AssessmentResult.prototype, "flaggedQuestions", {
        get: function () {
            return this._flaggedQuestions;
        },
        set: function (value) {
            this._flaggedQuestions = value;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentResult.prototype.getScaleResultByScaleId = function (scaleId) {
        // TODO: stephen optimize this later.
        var results = this.scaleResults.filter(function (s) {
            return s.scale != null && s.scale.id === scaleId;
        });
        if (results.length) {
            return results[0];
        }
        return null;
    };
    AssessmentResult.prototype.scaleHasHomework = function (scaleResult) {
        return scaleResult.range &&
            scaleResult.range.assignmentURL != null &&
            scaleResult.range.assignmentURL != null &&
            scaleResult.range.assignmentURL != "";
    };
    return AssessmentResult;
}());
export { AssessmentResult };



// WEBPACK FOOTER //
// ./src/app/shared/models/assessment-result.ts.pre-build-optimizer.js